import React, { Component, PropTypes } from 'react'
import styles from './Program.css'

class Option extends Component {

  render () {
    return (
      <div onClick={this._onClick} className='row'>
        <div style={{ fontSize: '15px' }} className='col-md-2 text-center v-center'>
          <img src={this.props.img} />
        </div>
        <div className={`col-md-10 v-center`}>
          <div className={`${styles['option-title']} ${this.props.isDisabled ? styles['option-title-disabled'] : ''}`}>{this.props.title}</div>
          <div className={`${styles['option-body']}`}>
            {this.props.body}
          </div>
        </div>
      </div>
    )
  }

  _onClick = () => {
    let {onClick, type} = this.props
    if (onClick) {
      this.props.onClick(type)
    }
  }
}

Option.propTypes = {
  isDisabled: PropTypes.bool,
  isSelected: PropTypes.bool,
  title: PropTypes.string,
  body: PropTypes.string
}

export default Option



// WEBPACK FOOTER //
// ./app/pages/Customers/Loyalty/Components/Program/Option.js